module.exports = __webpack_public_path__ + "static/amazon-67e0caf730e8cc0bd22c9f29954a74c9.png";